module.exports = __webpack_public_path__ + "static/logo-1de9cdfe7c6c2c9746ab282d1207d161.svg";